import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from "react-router-dom";
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';
import { useNavigateToMaintenancePlanCreate } from '../../helpers/MaintenancePlanUtilities';
import Toast from '../../helpers/Toast';
import { ClientDTO } from '../../models/Client/ClientDTO';
import { EquipmentDTO } from '../../models/Equipment/EquipmentDTO';
import { GetMaintenancePlansFromEquipmentRequestDTO } from '../../models/MaintenancePlan/GetMaintenancePlansFromEquipmentRequestDTO';
import { GetMaintenancePlansFromEquipmentResponseDTO } from '../../models/MaintenancePlan/GetMaintenancePlansFromEquipmentResponseDTO';
import { MaintenancePlanService } from '../../services/MaintenancePlanService';
import ButtonComponent from '../ButtonComponent';
import TableComponent, { OperationsCell } from "../TableComponent";

type MaintenancePlansFromEquipmentProps = {
    client: ClientDTO | null,
    equipment: EquipmentDTO | null
};

function MaintenancePlansFromEquipment({ ...props }: MaintenancePlansFromEquipmentProps) {
    const { id } = useParams<{ id: string }>();
    const maintenancePlanService = new MaintenancePlanService();
    const intl = useIntl();

    //#region Módulos ativos
    const { availableModules } = useAvailableModulesContext();
    const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
    useEffect(() => {
        if (availableModules.includes("IsActiveCarPlate")) {
            setIsActiveCarPlate(true);
        }
    }, [availableModules]);
    //endregion

    const [maintenancePlans, setMaintenancePlans] = useState<GetMaintenancePlansFromEquipmentResponseDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const columns = React.useMemo(
        () => [
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromEquipment.Table.Column.Numerator" />,
                accessor: "numerator",
                width: 10,
            },
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromEquipment.Table.Column.Name" />,
                accessor: "name",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromEquipment.Table.Column.PeriodicityType" />,
                accessor: "periodicityType",
                width: 15,
            },
            ...(isActiveCarPlate ? [{
                Header: <FormattedMessage id="Screens.MaintenancePlansFromEquipment.Table.Column.CarPlate" />,
                accessor: "carPlate",
                width: 15,
            }] : []),
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromEquipment.Table.Column.SerialNumber" />,
                accessor: "serialNumber",
                width: 15,
            },
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromEquipment.Table.Column.Brand" />,
                accessor: "brand",
                width: 15,
            },
            {
                Header: <FormattedMessage id="Screens.MaintenancePlansFromEquipment.Table.Column.Model" />,
                accessor: "model",
                width: 15,
            },
            {
                Header: "",
                accessor: " ",
                width: 10,
                Cell: (props: any) =>
                    OperationsCell(props.cell.row.original.id, "maintenancePlan"),

            },
        ],
        [isActiveCarPlate]
    );

    const GetMaintenancePlansFromEquipment = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data: GetMaintenancePlansFromEquipmentRequestDTO = {
            currentPage: currentPage,
            pageSize: pageSize,
        }
        var response = await maintenancePlanService.GetMaintenancePlansFromEquipment(id, data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);

            setMaintenancePlans([]);
            setPageCount(0);
            setPageSize(0);
            setCurrentPage(0);
            setGoToPage(0);

            return;
        }

        setMaintenancePlans(response.items);
        setIsLoading(false);
    }

    useEffect(() => {
        if (id && isLoading) {
            GetMaintenancePlansFromEquipment(currentPage ?? 1, pageSize ?? 5)
        }
    }, [])


    //#region Navegar para criação de um novo plano, passando dados do equipamento
    const navigateToCreate = useNavigateToMaintenancePlanCreate(); // tenho de fazer isto e não ser direto pq "React Hook "useNavigateToMaintenancePlanCreate" cannot be called inside a callback. React Hooks must be called in a React function component or a custom React Hook function"
    //endregion

    return (
        <div>
            <ButtonComponent
                text={intl.formatMessage({ id: "Screens.MaintenancePlansFromEquipment.Button.Create.MaintenancePlan" })}
                onClick={() => navigateToCreate(null, null, props?.client, props?.equipment)}
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                style={{ minHeight: "37px", minWidth: "100px", marginTop: "25px", marginBottom: "25px" }}
            />


            <TableComponent
                columns={columns}
                data={maintenancePlans}
                goToPage={goToPage}
                initialPage={currentPage}
                pageCount={pageCount}
                initialPageSize={pageSize}
                pageSizes={pageSizes}
                manualPagination={true}
                loading={isLoading}
                fetchData={GetMaintenancePlansFromEquipment}
                initialSortBy={[]}
                disableSortBy={true}
                dontOrderFirstCollumn={true}
            />
        </div>

    )
}

export default MaintenancePlansFromEquipment